export const isJSON = (str) => {
  if (typeof str !== 'string') return false;
  try {
    const result = JSON.parse(str);
    const type = Object.prototype.toString.call(result);
    return type === '[object Object]' || type === '[object Array]';
  } catch (err) {
    return false;
  }
}

export const isNumber = (number) => {
  if (typeof number !== 'string' && typeof number !== 'number') return false;
  if(String(Number(number)) === 'NaN') return false;
  if(number === null || number === undefined || number === '') return false;
  return true;
}